module.exports = __webpack_public_path__ + "static/media/SL_image.1915882d.mp3";